export function formatTimeAmPm(time) {
  if (time === undefined || time === null) {
    return "";
  }
  const timeRaw = time.toString().trim();
  const hhmm = timeRaw.length >= 5 ? timeRaw.slice(0, 5) : timeRaw;
  const [hourPart, minutePart] = hhmm.split(":");
  const hours = parseInt(hourPart, 10);
  const minutes = parseInt(minutePart ?? "0", 10);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return timeRaw;
  }
  const period = hours < 12 ? "A.M." : "P.M.";
  const displayHour = hours % 12 === 0 ? 12 : hours % 12;
  return `${displayHour}:${String(minutes).padStart(2, "0")} ${period}`;
}
